/**
 * The purchase steps a scan drives from inside the order and shipment drawers.
 * `ALREADY_PURCHASED` is the terminal one: the label purchased drawer is the end
 * of the flow, so no surface publishes a step for it and no surface should.
 */
export const DRAWER_SCAN_SUBMIT_INTENTS = {
  ALREADY_PURCHASED: 'DRAWER_ALREADY_PURCHASED',
  BUY_AND_PRINT: 'DRAWER_BUY_AND_PRINT',
  CHECKOUT: 'DRAWER_CHECKOUT',
  PRINT: 'DRAWER_PRINT',
} as const;

/** The app sections holding a drawer a scan can submit. */
export const DRAWER_SCAN_SUBMIT_ROUTES = ['orders', 'shipments'] as const;
